import { Link } from 'react-router-dom';
import { siteInfo, animeCategories } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="inline-block mb-4">
                <span className="text-xl font-heading font-bold text-primary-500 tracking-wide">
                  {siteInfo.name}
                </span>
              </Link>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                {siteInfo.description}
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-500 hover:bg-background-700 transition-all duration-200"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-500 hover:bg-background-700 transition-all duration-200"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-500 hover:bg-background-700 transition-all duration-200"
                  aria-label="Bilibili"
                  rel="nofollow"
                >
                  <i className="ri-bilibili-line text-base"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-foreground-100 font-heading font-semibold text-sm mb-4">
                番剧分类
              </h4>
              <ul className="flex flex-col gap-2">
                {animeCategories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-foreground-100 font-heading font-semibold text-sm mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link
                    to="/about"
                    className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">
                    版权声明
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-foreground-100 font-heading font-semibold text-sm mb-4">
                联系我们
              </h4>
              <ul className="flex flex-col gap-2 text-foreground-500 text-sm">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-base mt-0.5 text-primary-500"></i>
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-base mt-0.5 text-primary-500"></i>
                  <span>{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 本站所有内容均受版权保护
          </p>
          <p className="text-foreground-700 text-xs">
            <span className="text-primary-500 font-medium">{siteInfo.totalAnime}</span> 部番剧 ·{' '}
            <span className="text-accent-500 font-medium">{siteInfo.totalUsers}</span> 用户信赖之选
          </p>
        </div>
      </div>
    </footer>
  );
}